export default "__VITE_ASSET__85ec25ed__"